<div *ngIf="!isWrittenCheque" class="detail-card">
  <div class="d-flex flex-column gap-4">
    <div class="d-flex flex-column gap-1 flex-grow-1">
      <div class="deposit-title" i18n>Deposited To</div>
      <div class="bank-account-name">{{ bankAccount?.nickname }}</div>
    </div>
    <div class="d-flex flex-column gap-3">
      <div class="bank-info-grid">
        <app-review-entry label="Institution Number" i18n-label [value]="bankAccount?.institutionNumber" />
        <app-review-entry label="Transit Number" i18n-label [value]="bankAccount?.transitNumber" />
        <app-review-entry label="Account Number" i18n-label [value]="bankAccount?.accountNumber" />
      </div>
      <div i18n class="date-added">Date Added: {{ bankAccount?.createdDate | date : 'MMMM d, y' }}</div>
    </div>
  </div>
</div>

<div *ngIf="isWrittenCheque" class="detail-card">
  <div class="bank-account-name" i18n>Written Cheque</div>
</div>
